module.exports = __webpack_public_path__ + "static/33invgde-852314e9a5ff2e1e64033196cfd526a5.gif";